import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { Form, Input, message } from 'antd'

interface PasswordFormProps {
  accountInfo: { account: string; captcha: string } | null;
  loading: boolean;
  register: (data: { password: string; confirmPassword: string; agreeProtocol: boolean }) => Promise<boolean>;
  goBack: () => void;
}

const PasswordForm = (props: PasswordFormProps) => {
  const { loading, register } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm()

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      await register({
        password: values.password,
        confirmPassword: values.passwordRepeat,
        agreeProtocol: true,
      });
    } catch (error) {
      console.error('表单验证失败:', error);
    }
  };

  return (
    <div className='w-[486px] h-[536px] px-[38px] bg-white rounded-[12px] shadow-[0px_8px_18px_0px_rgba(18,37,196,0.06)] pt-[68px] pb-[96px] flex flex-col justify-start'>
      <LangText lngKey='b2db8fab' className='text-[24px] font-bold '>{t('b2db8fab')}</LangText>
      <Form form={form} layout="vertical" className='!mt-15' onFinish={handleSubmit}>
        <Form.Item
          name='password'
          required
          label={<LangText lngKey='70d6495a' className='text-[16px] font-bold'>{t('70d6495a')}</LangText>}
          rules={[
            { required: true, message: t('f039ef62') },
            { min: 6, message: t('69a859b3') },
            { max: 12, message: t('14ea58bf') },
            { pattern: /^[a-zA-Z0-9]+$/, message: t('69069764') },
          ]}
        >
          <Input.Password placeholder={t('44739ae4')} className='h-[44px]' />
        </Form.Item>
        <Form.Item
          name='passwordRepeat'
          required
          label={<LangText lngKey='4db6940d' className='text-[16px] font-bold'>{t('4db6940d')}</LangText>}
          dependencies={['password']}
          rules={[
            { required: true, message: t('928d5f22') },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('81dbebe1')));
              },
            }),
          ]}
        >
          <Input.Password placeholder={t('48194e92')} className='h-[44px]' />
        </Form.Item>
        <button
          type='submit'
          className={`w-full mt-[52px] rounded-[24px] bg-linear-to-r from-[#a75aff] to-[#4b51ff] h-[44px] cursor-pointer ${loading ? 'opacity-60' : ''
            }`}
          disabled={loading}
        >
          <LangText lngKey={loading ? 'ccf05210' : '930ab4e1'} className='text-[15px] text-white'>{loading ? t('ccf05210') : t('930ab4e1')}</LangText>
        </button>
      </Form>
    </div>
  )
}

export default PasswordForm